package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SwordsW500Rounded: ImageVector
    get() {
        if (_swordsW500Rounded != null) {
            return _swordsW500Rounded!!
        }
        _swordsW500Rounded = Builder(name = "SwordsW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(758.89f, 867.11f)
                lineTo(645.96f, 754.93f)
                lineToRelative(-61.68f, 61.68f)
                quadToRelative(-10.52f, 10.52f, -26.32f, 10.52f)
                quadToRelative(-15.81f, 0.0f, -26.33f, -10.52f)
                quadToRelative(-26.35f, -26.35f, -26.35f, -64.65f)
                quadToRelative(0.0f, -38.31f, 26.35f, -64.66f)
                lineTo(691.3f, 527.63f)
                quadToRelative(26.35f, -26.35f, 64.66f, -26.35f)
                quadToRelative(38.3f, 0.0f, 64.65f, 26.35f)
                quadToRelative(10.52f, 10.52f, 10.52f, 26.33f)
                quadToRelative(0.0f, 15.8f, -10.52f, 26.32f)
                lineToRelative(-61.68f, 61.68f)
                lineToRelative(112.18f, 112.93f)
                quadToRelative(13.67f, 13.68f, 13.67f, 32.07f)
                reflectiveQuadToRelative(-13.67f, 32.06f)
                lineToRelative(-48.09f, 48.09f)
                quadToRelative(-13.67f, 13.67f, -32.06f, 13.67f)
                reflectiveQuadToRelative(-32.07f, -13.67f)
                close()
                moveTo(871.83f, 251.83f)
                lineTo(430.54f, 693.11f)
                lineToRelative(3.81f, 3.04f)
                quadToRelative(21.32f, 25.87f, 19.77f, 60.95f)
                quadToRelative(-1.55f, 35.07f, -25.99f, 59.51f)
                quadToRelative(-10.52f, 10.52f, -26.33f, 10.52f)
                quadToRelative(-15.8f, 0.0f, -26.32f, -10.52f)
                lineToRelative(-61.68f, -61.68f)
                lineTo(200.87f, 867.11f)
                quadTo(187.2f, 880.78f, 168.8f, 880.78f)
                quadToRelative(-18.39f, 0.0f, -32.06f, -13.67f)
                lineToRelative(-48.09f, -48.09f)
                quadToRelative(-13.67f, -13.67f, -13.67f, -32.06f)
                reflectiveQuadToRelative(13.67f, -32.07f)
                lineToRelative(112.18f, -112.93f)
                lineToRelative(-61.68f, -61.68f)
                quadToRelative(-10.52f, -10.52f, -10.52f, -26.32f)
                quadToRelative(0.0f, -15.81f, 10.52f, -26.33f)
                quadToRelative(24.44f, -24.43f, 59.63f, -25.99f)
                quadToRelative(35.2f, -1.55f, 61.07f, 20.01f)
                lineToRelative(3.04f, 3.81f)
                lineToRelative(428.37f, -428.61f)
                quadToRelative(12.67f, -12.68f, 29.21f, -19.51f)
                quadToRelative(16.53f, -6.84f, 34.68f, -6.84f)
                lineTo(840.0f, 70.5f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadTo(885.5f, 96.85f, 885.5f, 116.0f)
                verticalLineToRelative(103.24f)
                quadToRelative(0.0f, 9.19f, -3.48f, 17.53f)
                quadToRelative(-3.48f, 8.34f, -10.19f, 15.06f)
                close()
                moveTo(335.67f, 374.37f)
                lineToRelative(21.61f, -20.85f)
                lineToRelative(20.85f, -21.61f)
                lineToRelative(-20.85f, 21.61f)
                lineToRelative(-21.61f, 20.85f)
                close()
                moveTo(241.35f, 405.48f)
                lineTo(100.85f, 264.74f)
                quadToRelative(-12.44f, -12.67f, -19.39f, -29.21f)
                quadTo(74.5f, 219.0f, 74.5f, 200.85f)
                lineTo(74.5f, 116.0f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadTo(100.85f, 70.5f, 120.0f, 70.5f)
                horizontalLineToRelative(84.85f)
                quadToRelative(18.39f, 0.0f, 34.8f, 6.84f)
                quadToRelative(16.42f, 6.83f, 29.09f, 19.51f)
                lineToRelative(141.5f, 141.74f)
                quadToRelative(13.19f, 13.19f, 12.69f, 31.11f)
                quadToRelative(-0.5f, 17.91f, -13.69f, 31.1f)
                quadToRelative(-13.2f, 12.44f, -31.11f, 12.82f)
                quadToRelative(-17.91f, 0.38f, -31.11f, -12.82f)
                lineTo(205.57f, 159.11f)
                horizontalLineToRelative(-42.46f)
                verticalLineToRelative(42.46f)
                lineToRelative(141.46f, 141.69f)
                quadToRelative(12.43f, 12.44f, 12.31f, 30.73f)
                quadToRelative(-0.12f, 18.29f, -12.55f, 31.49f)
                quadToRelative(-13.2f, 13.19f, -31.49f, 13.19f)
                quadToRelative(-18.3f, 0.0f, -31.49f, -13.19f)
                close()
                moveTo(369.76f, 628.93f)
                lineTo(796.89f, 201.57f)
                verticalLineToRelative(-42.46f)
                horizontalLineToRelative(-42.46f)
                lineTo(327.07f, 586.24f)
                lineToRelative(42.69f, 42.69f)
                close()
                moveTo(369.76f, 628.93f)
                lineTo(348.15f, 607.85f)
                lineTo(327.07f, 586.24f)
                lineTo(348.15f, 607.85f)
                lineTo(369.76f, 628.93f)
                close()
            }
        }
        .build()
        return _swordsW500Rounded!!
    }

private var _swordsW500Rounded: ImageVector? = null
